import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import CatalogItemsGrid from './CatalogItemsGrid';
import TextWithCut from './TextWithCut';

function Catalog({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const cols = info.extra?.elementsInARow || 3;
    const content = info.extra?.content || '';
    const descriptionCut = info.extra?.description_cut || 'none';
    const rows = info.extra?.rows || [];

    return (
        <div className="justify" style={{ width: '100%' }}>
            {info.caption && !(typeof content === "string" && content) && <h1>{info.caption}</h1>}
            {typeof content === "string" && content ? (
                <TextWithCut cut={descriptionCut} value={parse(content)} />
            ) : null}

            <CatalogItemsGrid children={info.children} rows={rows} elementsInARow={cols} currentSlug={slug} />

            {slug.split('/').length > 1 &&
                <button
                    className="btn-back"
                    onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
                >
                    Go Back
                </button>
            }
        </div>
    );
}

export default Catalog;
